import React from "react";
import ReactDOM from "react-dom";
import "./styles/index.scss";
// import * as serviceWorker from "./serviceWorker";
import App from "./App";
import { Helmet } from "react-helmet";
import 'animate.css';
const crossOriginOpenerPolicy = "same-origin-allow-popups";

const helmet = (
  <Helmet>
    <meta http-equiv="Cross-Origin-Opener-Policy" content={crossOriginOpenerPolicy} />
  </Helmet>
);

ReactDOM.render(
  <>
    {helmet}
    <App />
  </>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
